module.exports = __webpack_public_path__ + "img/english-energy-catalog.2e1294b1.webp";